import React from "react";
import './EmptyTodos.css';

export function EmptyTodos() {
    return <p className="empty-title">¡Crea tu primer TODO!</p>;
}